// extracted by mini-css-extract-plugin
export default {"wrapper":"Send_wrapper__Vt9RO","icon-container":"Send_icon-container__DtoZ7","icon":"Send_icon__2ftD3","card":"Send_card__AIjF6"};